import { History, LocationState } from 'history';
import { action, makeObservable, observable, runInAction } from "mobx";
import { RouterStore, syncHistoryWithStore } from "mobx-react-router";
import { BaseStore } from ".";



export class RoutingStore extends RouterStore implements BaseStore {

  // Important props of the base class:
  // history:  History;
  // location: Location;
  private isSynced: boolean = false;

  pathName:   string = null;
  navBarSize: string = null;
  boardDirection: 'horizontal' | 'vertical' = 'vertical';

  constructor() {
    super();

    makeObservable(this, {
      syncHistory:     action,
      setNavBarHeight: action,
      toggleBoardView: action,
      pathName:        observable,
      navBarSize:      observable,
      boardDirection:  observable,
    });
  }

  init() { }

  clear = () => {}

  /**
   * Extending the RouterStore screws up mobx observables. 
   * 
   * @param history 
   */
  syncHistory = (history: History<LocationState>): History<LocationState> => {
    if(this.isSynced) return this.history;
    this.isSynced = true;
    
    syncHistoryWithStore(history, this);

    makeObservable(this, {
      history:  observable,
      location: observable,
    });

    // Set initial pathname incase the user accessed through a direct link
    this.pathName = location.pathname;

    // Register additional listener since inhertance screws up mobx. 
    this.history.listen((location) => runInAction(() => {
      this.pathName = location.pathname;
    }));
    
    return this.history;
  }

  get getPathName(): string {
    return this.pathName;
  }

  setNavBarHeight = (height: string) => {
    this.navBarSize = height;
  }

  toggleBoardView = (view?: 'horizontal' | 'vertical') => {
    if(view) this.boardDirection = view;
    if(!view) this.boardDirection = this.boardDirection == 'vertical' ? 'horizontal' : 'vertical'
  }
}